import { useMemo } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { createIndustryQueryClient } from "../queries/client/factory";

/**
 * React hook wrapper around the industry query client.
 */
export const useIndustryQueryClient = () => {
    const queryClient = useQueryClient();

    return useMemo(() => createIndustryQueryClient({ queryClient }), [queryClient]);
};
